import React, { useMemo, useState, useEffect } from "react"

import { Container, CardBody, Card, Modal, ModalBody } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"
import { axiosbaseurl } from "configure"
import moment from "moment"
import Loader from "components/Common/Loader"

import { DatePicker } from "antd"
import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import CommonTable from "components/Common/CommonTable"

const { RangePicker } = DatePicker

const ScheduledEmailLogs = () => {
  const [table_data, settable_data] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getLogsData(
      moment().subtract(30, "days").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    )
  }, [])

  const getLogsData = async (startDate, endDate) => {
    try {
      setLoading(true)
      const response = await axiosbaseurl.get(
        `/activity-logs/scheduled-email/logs?startDate=${startDate}&endDate=${endDate}`
      )
      if (response.data.success) {
        settable_data(response.data.data)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  document.title = "Scheduled Email Logs | Peacock Accountants Limited"

  return (
    <>
      {loading && <Loader />}
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb
            title={"Dashboard"}
            breadcrumbItem={"Scheduled Email Logs"}
          />

          <Card className="px-0 mx-0">
            <CardBody>
              <TableComponent
                table_data={table_data}
                getLogsData={getLogsData}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}

const TableComponent = ({ table_data, getLogsData }) => {
  // State variables
  const [dateRange, setDateRange] = useState(["", ""])

  const { checkAccess } = usePermissionData()
  const module_id = 25

  const navigate = useNavigate()

  // columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        filterable: true,
        disableFilters: true,
        className: "text-center",
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        filterable: true,
        className: "col-3",
      },
      {
        Header: "Description",
        accessor: "description",
        disableFilters: true,
        filterable: true,
        className: "col-7",
      },
      {
        Header: "Scheduled Date & Time",
        accessor: "createdAt",
        disableFilters: true,
        filterable: true,
        className: "col-2",
        Cell: cellProps => {
          return (
            <span>
              {moment(cellProps.row.original.createdAt).format(
                "DD MMM YYYY | hh:mm A"
              )}
            </span>
          )
        },
      },
    ],
    []
  )

  // table data
  const data = useMemo(() => table_data, [table_data])

  // Filter records based on the date range
  const handleFilter = ([start, end]) => {
    if (start && end) {
      getLogsData(start, end)
    } else {
      getLogsData(
        moment().subtract(30, "days").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      )
    }
  }

  const handleReset = () => {
    if (dateRange[0] && dateRange[1]) {
      getLogsData(
        moment().subtract(30, "days").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      )
      setDateRange(["", ""])
    }
  }

  return (
    <>
      <PermittedComponent isAccess={checkAccess(module_id, "view")}>
        <CommonTable
          columns={columns}
          data={data}
          heading={
            <div className="d-flex align-items-center">
              <div>
                <RangePicker
                  onChange={(_, dateString) => {
                    setDateRange(dateString)
                    handleFilter(dateString)
                  }}
                  value={
                    dateRange[0] && dateRange[1]
                      ? [moment(dateRange[0]), moment(dateRange[1])]
                      : null
                  }
                  className="py-2 rounded"
                />
              </div>

              <div>
                <button
                  type="button"
                  onClick={handleReset}
                  className="btn btn-primary ms-2"
                  disabled={dateRange.includes("")}
                >
                  <i className="fas fa-undo me-2"></i> Reset
                </button>
              </div>
            </div>
          }
        >
          <div>
            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary bg-dark ms-3"
            >
              <i className="fas fa-arrow-left me-3"></i>
              Back
            </button>
          </div>
        </CommonTable>
      </PermittedComponent>
    </>
  )
}

export default ScheduledEmailLogs
